import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, FieldSelect, ModalBody, ModalFoot, ModalHead, } from '@dixa/lib-shared-habla';
import { useCallback, useMemo, useState } from 'react';
import { connect } from 'react-redux';
import { FlowNodeTypes } from 'components/powerFlowShared/components/types';
import { getConfirmButtonVerb } from 'components/powerFlowShared/helpers/getConfirmButtonVerb';
import { useIsChanged } from 'components/powerFlowShared/hooks/useIsChanged';
import { QueuePicker } from 'components/shared/queuePicker';
const QUEUE_FIELD = 'queue';
const EMAIL_FIELD = 'fromEmail';
const ContactFormModalImpl = ({ fromEmails, node, nodeLabel, replaceNode, triggerClose, }) => {
    const { payload } = node;
    const [errors, setErrors] = useState({});
    const [{ queue, fromEmail }, setState] = useState(Object.assign({ queue: null }, payload));
    const isChanged = useIsChanged([payload === null || payload === void 0 ? void 0 : payload.queue, queue], [payload === null || payload === void 0 ? void 0 : payload.fromEmail, fromEmail]);
    const validate = useCallback(() => {
        const errors = {};
        if (!(queue === null || queue === void 0 ? void 0 : queue.value)) {
            errors[QUEUE_FIELD] = 'Selecting a queue is required';
        }
        setErrors(errors);
        return Object.keys(errors).length === 0;
    }, [queue]);
    const handleQueueChange = useCallback((queue) => {
        if (!queue) {
            return;
        }
        setState((state) => (Object.assign(Object.assign({}, state), { queue: {
                value: queue.id,
                label: queue.name,
            } })));
    }, []);
    const handleEmailChange = useCallback((emailAddress) => {
        setState((state) => (Object.assign(Object.assign({}, state), { fromEmail: emailAddress })));
    }, []);
    const handleSaveClick = useCallback(() => {
        if (!validate()) {
            return;
        }
        const nodeOptions = Object.assign(Object.assign({}, node), { badges: [], childIds: [], icon: '', isAction: false, isEditable: true, isRemovable: true, nodeType: FlowNodeTypes.CONTACT_FORM, overlay: [], payload: Object.assign({ queue }, (fromEmail && { fromEmail })), text: '' });
        replaceNode(nodeOptions);
        triggerClose();
    }, [node, queue, fromEmail, replaceNode, triggerClose, validate]);
    const emailItems = useMemo(() => fromEmails.map(({ email_address, sender_name }) => ({
        id: email_address,
        name: sender_name ? `${sender_name} <${email_address}>` : email_address,
    })), [fromEmails]);
    return (_jsxs(Box, Object.assign({ width: "600px" }, { children: [_jsx(ModalHead, { onClose: triggerClose, title: nodeLabel }), _jsxs("form", Object.assign({ onSubmit: handleSaveClick }, { children: [_jsxs(ModalBody, { children: [_jsx(QueuePicker, { required: true, selectedQueue: queue, label: "Select queue", placeholder: "No queue selected", meta: { error: errors[QUEUE_FIELD] }, input: {
                                    name: QUEUE_FIELD,
                                    onChange: handleQueueChange,
                                } }), _jsx(FieldSelect, { label: "Email", input: {
                                    name: EMAIL_FIELD,
                                    value: fromEmail !== null && fromEmail !== void 0 ? fromEmail : '',
                                    onChange: handleEmailChange,
                                }, items: emailItems, placeholder: "Select an email", clearable: true, searchable: true })] }), _jsx(ModalFoot, { cancelOnClick: triggerClose, confirmName: getConfirmButtonVerb(node), confirmProps: { disabled: !isChanged }, confirmOnClick: handleSaveClick })] }))] })));
};
const mapStateToProps = ({ composeEmail: { fromEmails }, }) => ({
    fromEmails,
});
export const ContactFormModal = connect(mapStateToProps)(ContactFormModalImpl);
